import React from 'react'
import './style.css'
export default function eventsCategory(props) {
  return (
    <>
        <button className='eventCategoryName eventCategoryButton' onClick={props.functionName}>{props.eventCategory}</button>
    </>
  )
}
